import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@env/environment';
import { EnvironmentType } from '@app/shared/enums/environment-type.enum';

// FixMe: Angular12Upgrade: find a place to put this...
import '../node_modules/anychart/dist/js/anychart-bundle.min.js';


if (environment.instance == EnvironmentType.Production || environment.instance == EnvironmentType.Sandbox) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
